module.exports = __webpack_public_path__ + "media/img/description/contact-us-decoration-9dd491e11736a4f9b9a4f8f5f5ff7d37.svg";